import hubStorage from '@/helpers/hubStorage';
import { authActionType } from '@/vuex-store/auth/actions';
import { authGetterType } from '@/vuex-store/auth/getters';
export default async function parseQueryToken({ to, next, store }) {
    const { token, ...withoutToken } = to.query;
    if (token) {
        store.dispatch(authActionType.setAccessToken, token);
        // query Token으로 진입했을 경우 localStorage에 selectedHubInfo가 있을 시 초기화하기
        hubStorage.removeSelectedHubInfo();
        hubStorage.setItem({
            key: 'queryTokenLoginUser',
            value: 1,
        });
        // query Token으로 진입했을 경우 새로고침 여부 채크를 위해 필요
        hubStorage.setSessionItem({
            key: 'reloaded',
            value: 1,
        });
        const qs = new URLSearchParams(withoutToken).toString();
        window.location.replace(`${to.path}?${qs}`);
        return null;
    }
    const isAuthenticated = store.getters[authGetterType.isAuthenticated];
    if (isAuthenticated) {
        return next();
    }
    return next({
        name: 'Login',
    });
}
